module.exports = __webpack_public_path__ + "img/2262746_m.c26090bd.jpg";